"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var saveToDisk_1 = require("../../../common/helpers/saveToDisk");
var splitFormDataByFile_1 = require("../../../common/helpers/splitFormDataByFile");
var permitImages_1 = require("../../../common/helpers/permitImages");
var StudentAccountEditPermitController = /** @class */ (function () {
    function StudentAccountEditPermitController($state, UserService, UsersModel, FlashService, PermitModel, permitData, FilesModel, $q) {
        this.initialLoad = true;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.PermitModel = PermitModel;
        this.FlashService = FlashService;
        this.submitted = false;
        this.FilesModel = FilesModel;
        this.files = permitData.files;
        this.$q = $q;
        this.handlePermitFrontUpload = this.handlePermitFrontUpload.bind(this);
        this.handlePermitBackUpload = this.handlePermitBackUpload.bind(this);
        this.permit = {
            number: "",
            issue_date: "",
            expiration_date: "",
        };
        if (permitData.permit.number) {
            this.permit.number = permitData.permit.number;
        }
        if (permitData.permit.issuedate) {
            this.permit.issue_date = (0, time_1.dateStringToDate)(permitData.permit.issuedate);
        }
        if (permitData.permit.expirationdate) {
            this.permit.expiration_date = (0, time_1.dateStringToDate)(permitData.permit.expirationdate);
        }
        this.updateIssueDate = this.updateIssueDate.bind(this);
        this.updateExpirationDate = this.updateExpirationDate.bind(this);
    }
    StudentAccountEditPermitController.prototype.formatDate = function (datestring) {
        return new Date(datestring).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    StudentAccountEditPermitController.prototype.deleteFile = function (id) {
        var _this = this;
        this.FilesModel.destroy(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.files = _this.files.filter(function (file) {
                return file.id !== id;
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong deleting the file.",
            });
        });
    };
    StudentAccountEditPermitController.prototype.downloadFile = function (id) {
        var _this = this;
        this.FilesModel.get(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.temporary_url);
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong downloading the file.",
            });
        });
    };
    StudentAccountEditPermitController.prototype.frontImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_FRONT_TYPE);
    };
    StudentAccountEditPermitController.prototype.backImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_BACK_TYPE);
    };
    StudentAccountEditPermitController.prototype.handlePermitFrontUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_FRONT_TYPE);
    };
    StudentAccountEditPermitController.prototype.handlePermitBackUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_BACK_TYPE);
    };
    StudentAccountEditPermitController.prototype.uploadPermitImage = function (formData, fileType) {
        var _this = this;
        var uploads = (0, splitFormDataByFile_1.splitFormDataByFile)(formData).map(function (singleFileFormData) {
            singleFileFormData.append("students", JSON.stringify([_this.UserService.getCurrentUser().id]));
            return _this.FilesModel.uploadFile(fileType, fileType, singleFileFormData);
        });
        this.$q
            .all(uploads)
            .then(function (responses) {
            responses.forEach(function (response) {
                _this.files.push(response.file);
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong uploading the file.",
            });
        });
    };
    StudentAccountEditPermitController.prototype.updateIssueDate = function (newDate) {
        this.permit.issue_date = newDate.selected[0];
    };
    StudentAccountEditPermitController.prototype.updateExpirationDate = function (newDate) {
        this.permit.expiration_date = newDate.selected[0];
    };
    StudentAccountEditPermitController.prototype.updatePermit = function () {
        var _this = this;
        this.submitted = true;
        var permit = {
            number: this.permit.number,
            issue_date: (0, time_1.toYMDOrEmpty)(this.permit.issue_date),
            expiration_date: (0, time_1.toYMDOrEmpty)(this.permit.expiration_date),
        };
        this.PermitModel.update(this.UserService.getCurrentUser().id, permit)
            .then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.student.dashboard");
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return StudentAccountEditPermitController;
}());
StudentAccountEditPermitController.$inject = [
    "$state",
    "UserService",
    "UsersModel",
    "FlashService",
    "PermitModel",
    "permitData",
    "FilesModel",
    "$q",
];
exports.default = StudentAccountEditPermitController;
